import React, { Component } from "react";
import { List, Typography, Empty, Tag, Spin, message } from "antd";
import { ModalItem } from "../../../../Components/Items"; // Ajusta tus imports
import { CarOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import axios from "axios";

const { Text, } = Typography;

class ModalUsosPoliza extends Component {
  state = {
    loading: false,
    usos: [],
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.buscarUsos();
    }
  }

  buscarUsos = async () => {
    this.setState({ loading: true, usos: [] });
    axios
      .post(
        "/polizasSeguro/buscarUsosPoliza",
        {
          polizaId: this.props.polizaId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ usos: res.data.data });
        } else {
          message.error(res.data.message || "Error al buscar usos");
        }
      })
      .catch((error) => {
        message.error("Error de conexión");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { visible, onCancel } = this.props;
    const { usos, loading } = this.state;

    return (
      <ModalItem
        title={
          <span>
            <SafetyCertificateOutlined style={{ marginRight: 8 }} />
            Uso de Póliza en Proyectos
          </span>
        }
        visible={visible}
        onCancel={onCancel}
        width={600}
        destroyOnClose
        spinning={this.state.loading}
      >
        <Spin spinning={loading}>
          {usos.length > 0 ? (
            <List
              itemLayout="horizontal"
              dataSource={usos}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    avatar={
                      <div
                        style={{
                          backgroundColor: "#f0f2f5",
                          padding: 10,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <CarOutlined
                          style={{ fontSize: "20px", color: "#1890ff" }}
                        />
                      </div>
                    }
                    title={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Text strong>{item.nombre.toUpperCase()}</Text>
                        <Tag color="blue">{item.tipoUso}</Tag>
                      </div>
                    }
                    description={
                      <div>
                        <Text type="secondary" style={{ fontSize: "12px" }}>
                          {item.descripcion}
                        </Text>
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
          ) : (
            <Empty
              description="Esta póliza no está asignada a ningún proyecto móvil actualmente."
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          )}
        </Spin>
      </ModalItem>
    );
  }
}

export default ModalUsosPoliza;
